import { DotsLoader } from 'Components/DotsLoader';
import { ButtonForm, CustomTextField } from 'Components/Form/styles';
import { Column, Row } from 'Components/Grid';
import { useForm } from 'react-hook-form';
import { useMutation, useQuery } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { createUserOnboarding } from 'services/users-service';
import { HasAccount, SubtitleLogin, TitleLogin } from './styles';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import { getPresetPlan } from 'services/company-service';
import { useTranslation } from 'react-i18next';

export const OnboardCompanyAdmin = () => {
  const { t } = useTranslation(['company']);
  const { slug } = useParams();
  const SwalReact = withReactContent(Swal);
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
  } = useForm({
    defaultValues: {
      name: '',
      email: '',
    },
  });
  const { data: presetPlan } = useQuery(['getPresetPlan', slug], async () => {
    if (!slug) return null;
    const result = await getPresetPlan(slug);
    return result?.data ? result?.data : null;
  });

  const mutation = useMutation(
    newUser => {
      return createUserOnboarding(newUser);
    },
    {
      onError: error => {
        // An error happened!
        SwalReact.fire({
          title: t('company:onboard.admin.errorTitle'),
          text: error.response.data.message ?? error.message,
          icon: 'error',
        });
      },
      onSuccess: data => {
        if (data.status === 200 || data.status === 201) {
          if (!presetPlan || (presetPlan && presetPlan.plan !== 'Free')) {
            navigate(`/onboard-choose-plan/${slug}`);
          } else if (presetPlan && presetPlan.plan === 'Free') {
            const urlSplit = window.location.origin.split('/');
            const baseUrl = urlSplit[2].substring(3);
            window.location.href = `https://${slug}.${baseUrl}/login`;
          }
        }
      },
    },
  );

  const onSubmit = () => {
    const userData = getValues();
    mutation.mutate({
      name: userData.name,
      email: userData.email,
      active: true,
      permissions: [
        {
          roleKey: 'admin_customer',
          companyKey: slug,
        },
      ],
    });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="pt-5">
      <Row justifyContent="center" className="mt-5">
        <Column xs={12} className="text-center mb-3">
          <TitleLogin>Virtual</TitleLogin>
          <TitleLogin className="bold"> Officer</TitleLogin>
        </Column>
        <Column xs={12} className="text-center mb-4">
          <SubtitleLogin>{t('company:onboard.admin.subtitle')}</SubtitleLogin>
        </Column>
      </Row>
      {!mutation.isSucess && (
        <>
          <Row justifyContent="center">
            <Column xs={8} sm={6} className="mx-auto mb-4" justifyContent="center" flex>
              <CustomTextField
                {...register('name', { required: t('company:onboard.admin.nameRequired') })}
                label={t('company:onboard.admin.name')}
                name="name"
                error={errors?.name ? true : false}
                helperText={errors?.name ? errors.name.message : null}
                InputLabelProps={{ shrink: true }}
                sx={{
                  input: {
                    padding: '16.5px 10px',
                    width: '100%',
                  },
                  '.MuiOutlinedInput-root': {
                    padding: 0,
                  },
                  width: '100%',
                }}
              />
            </Column>
          </Row>
          <Row justifyContent="center">
            <Column xs={8} sm={6} className="mx-auto mb-4" justifyContent="center" flex>
              <CustomTextField
                {...register('email', { required: t('company:onboard.admin.emailRequired') })}
                label={t('company:onboard.admin.email')}
                name="email"
                error={errors?.email ? true : false}
                helperText={errors?.email ? errors.email.message : null}
                InputLabelProps={{ shrink: true }}
                sx={{
                  input: {
                    padding: '16.5px 10px',
                    width: '100%',
                  },
                  '.MuiOutlinedInput-root': {
                    padding: 0,
                  },
                  width: '100%',
                }}
              />
            </Column>
          </Row>
          <Row justifyContent="center">
            <Column xs={8} sm={6} className="mx-auto mb-2" justifyContent="center" flex>
              <ButtonForm
                className="full center"
                label={mutation.isLoading ? <DotsLoader /> : t('company:onboard.admin.continue')}
                type="submit"
              />
            </Column>
          </Row>
        </>
      )}
      <Row justifyContent="center" className="mb-2">
        <Column xs={12} className="text-center">
          <HasAccount>
            {t('company:onboard.admin.hasAccount')}{' '}
            <button
              type="button"
              onClick={() => (window.location.href = `http://${slug}.virtualofficer.local:3000/login`)}
            >
              Login
            </button>
            <br />
            <br />
            {/* <button>Não recebi instruções de confirmação</button> */}
          </HasAccount>
        </Column>
      </Row>
    </form>
  );
};
